import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/no-data.png'


const _hoisted_1 = { class: "ma--top-1" }
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "loading-pulse" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "row"
}
const _hoisted_6 = { class: "col-xl-12" }
const _hoisted_7 = { class: "card ma--bottom-1" }
const _hoisted_8 = { class: "card-header" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-upload btn--icon__prefix" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "btn--name" }, "Upload", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-upload btn--icon__prefix" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "btn--name" }, "Upload Service Titan", -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "card-content" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "ma-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "color--tertiary-blue text--weight-bold" }, "Manual upload files")
], -1)
const _hoisted_17 = {
  key: 0,
  class: "table table--striped"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "text--align-left",
      width: "15%"
    }, "File Name"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text--align-left",
      width: "10%"
    }, "Date "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text--align-left",
      width: "10%"
    }, "Status"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text--align-left",
      width: "15%"
    }, "Actions")
  ])
], -1)
const _hoisted_19 = { class: "text--align-left" }
const _hoisted_20 = { class: "text--align-left" }
const _hoisted_21 = { class: "text--align-left" }
const _hoisted_22 = { class: "text--align-left" }
const _hoisted_23 = {
  key: 0,
  class: "btn--group"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { colspan: "11" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "table__body--empty" }, [
    /*#__PURE__*/_createElementVNode("div", null, "No data to display"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "No Data"
    })
  ])
], -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "ma-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "color--tertiary-blue text--weight-bold" }, "Service Titan Records")
], -1)
const _hoisted_29 = { class: "table table--striped" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, [
      /*#__PURE__*/_createTextVNode(" File Name "),
      /*#__PURE__*/_createElementVNode("div", {
        class: "info right",
        "data-tooltip": "File Name of the record."
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-center" }, [
      /*#__PURE__*/_createTextVNode(" Record Count "),
      /*#__PURE__*/_createElementVNode("div", {
        class: "info right",
        "data-tooltip": "No of records in the file."
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-center" }, [
      /*#__PURE__*/_createTextVNode(" Client Name "),
      /*#__PURE__*/_createElementVNode("div", {
        class: "info",
        "data-tooltip": "Name of the client."
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-center" }, [
      /*#__PURE__*/_createTextVNode(" Time Sent "),
      /*#__PURE__*/_createElementVNode("div", {
        class: "info left",
        "data-tooltip": "Time the record was sent."
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-center" }, [
      /*#__PURE__*/_createTextVNode(" Status "),
      /*#__PURE__*/_createElementVNode("div", {
        class: "info left",
        "data-tooltip": "File Status."
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-center" }, [
      /*#__PURE__*/_createTextVNode(" Actions "),
      /*#__PURE__*/_createElementVNode("div", {
        class: "info left",
        "data-tooltip": "File Status."
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
      ])
    ])
  ])
], -1)
const _hoisted_31 = { class: "text--align-center" }
const _hoisted_32 = { class: "text--align-center" }
const _hoisted_33 = { class: "text--align-center" }
const _hoisted_34 = { class: "text--align-center" }
const _hoisted_35 = { class: "text--align-center" }
const _hoisted_36 = { class: "text--align-left" }
const _hoisted_37 = { class: "btn--group" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { key: 0 }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "table__body--empty" }, [
    /*#__PURE__*/_createElementVNode("div", null, "No data to display"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "No Data"
    })
  ])
], -1)
const _hoisted_41 = [
  _hoisted_40
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadFilePurchaseLeads = _resolveComponent("UploadFilePurchaseLeads")!
  const _component_UploadServiceTitan = _resolveComponent("UploadServiceTitan")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: "btn btn--green",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleUploadFile = true))
                }, _hoisted_11),
                _createElementVNode("button", {
                  class: "btn btn--green",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleServiceTitan = true))
                }, _hoisted_14)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                (_ctx.uploadData)
                  ? (_openBlock(), _createElementBlock("table", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadData, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.$filters.numberDisplay(item.fileName)), 1),
                            _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.$filters.dateDisplay(item.createdTime, "MM/DD/YYYY HH:mm A")), 1),
                            _createElementVNode("td", _hoisted_21, _toDisplayString(item.status == "NEW" ? "PROCESSING" : "COMPLETED"), 1),
                            _createElementVNode("td", _hoisted_22, [
                              (item.status == 'ORDER_CREATED')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    _createElementVNode("a", {
                                      class: "btn--link color--secondary-blue ma--right-1",
                                      onClick: ($event: any) => (
                          _ctx.downloadFile(item)
                        )
                                    }, " Download ", 8, _hoisted_24)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128)),
                        (_ctx.uploadData.length == 0 && !_ctx.loading)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_25, _hoisted_27))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_28,
                _createElementVNode("table", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serviceTitanResponse, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_31, _toDisplayString(item.fileName), 1),
                        _createElementVNode("td", _hoisted_32, _toDisplayString(item.recordCount), 1),
                        _createElementVNode("td", _hoisted_33, _toDisplayString(item.clientName), 1),
                        _createElementVNode("td", _hoisted_34, _toDisplayString(item.timeSent), 1),
                        _createElementVNode("td", _hoisted_35, _toDisplayString(item.status), 1),
                        _createElementVNode("td", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("a", {
                              class: "btn--link color--secondary-blue ma--right-1",
                              onClick: ($event: any) => (
                            _ctx.downloadServiceTitanFile(item)
                          )
                            }, " Download ", 8, _hoisted_38)
                          ])
                        ])
                      ]))
                    }), 128)),
                    (_ctx.serviceTitanResponse.length == 0 && !_ctx.loading)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_39, _hoisted_41))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.toggleUploadFile)
                  ? (_openBlock(), _createBlock(_component_UploadFilePurchaseLeads, {
                      key: 1,
                      adminSiteId: _ctx.adminSiteId,
                      selectedLeads: _ctx.selectedLeadsArr,
                      leadRequest: null,
                      totalLeads: null,
                      siteId: _ctx.adminSiteId,
                      purchaseType: "purchaseLead",
                      onPurchase: _ctx.updatePurchaseModel,
                      onClose: _ctx.closeUploadFile
                    }, null, 8, ["adminSiteId", "selectedLeads", "siteId", "onPurchase", "onClose"]))
                  : _createCommentVNode("", true),
                (_ctx.toggleServiceTitan)
                  ? (_openBlock(), _createBlock(_component_UploadServiceTitan, {
                      key: 2,
                      onClose: _ctx.closeServiceTitan
                    }, null, 8, ["onClose"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
  ]))
}